module.exports = __webpack_public_path__ + "static/media/咨询行业解决方案.c1d9c54f.png";